import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { NoddiButton, type ScreenBaseWrapperWidth, useIsWithinTailWindBreakpoint } from 'noddi-ui-web';
import { useSidebar } from 'noddi-ui-web/src/base';
import { BrandLogo } from '../Brand/BrandLogo';
import { NewBookingButton } from '../Common/NewBookingButton';
import { LogoLink } from './LogoLink';
import { NavWrapper } from './NavWrapper';

type HomeHeaderNavProps = {
  width?: ScreenBaseWrapperWidth;
};

export const HomeHeaderNav = ({ width }: HomeHeaderNavProps) => {
  const isMd = useIsWithinTailWindBreakpoint('md');
  const { toggleSidebar } = useSidebar();

  return (
    <NavWrapper width={width}>
      <div className='flex w-full items-center gap-5'>
        <LogoLink>
          <BrandLogo />
        </LogoLink>

        <div className='ml-auto flex items-center gap-2 sm:gap-3'>
          {/* Same Book CTA the logged-out header carries. Desktop only — beside the logo and
              Menu it crowds a phone header, so on mobile the page header carries it instead. */}
          {!isMd && <NewBookingButton actionText={t`Book`} endIcon='Calendar' defaultSize />}
          <NoddiButton
            variant='outline'
            size={isMd ? 'small' : 'default'}
            className='border-none'
            endIcon='Menu'
            onClick={toggleSidebar}
          >
            <Trans>Menu</Trans>
          </NoddiButton>
        </div>
      </div>
    </NavWrapper>
  );
};
